import React from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import pubsub from 'pubsub-js'
import moment from 'moment'
import { TICKETING_APP } from '../../utils/consts'

class NotificationItem extends React.Component {
  constructor() {
    super()

    this.state = {
      isHovering: false,
      isRead: false,
      canClick: true
    }

    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.goToPath = this.goToPath.bind(this)
    this.markAsRead = this.markAsRead.bind(this)
    this.openFeedbackModal = this.openFeedbackModal.bind(this)
  }

  openFeedbackModal() {
    pubsub.publish('openFeedbackSurvey', this.props.refId)
  }

  componentDidMount() {
    this.setState({
      isRead: this.props.isRead
    })

    pubsub.subscribe('haltClicks', () => {
      this.setState({
        canClick: false
      })
      setTimeout(() => {
        this.setState({
          canClick: true
        })
      }, 10000)
    })
  }

  onMouseLeave() {
    this.setState({
      isHovering: false
    })
  }

  onMouseEnter() {
    this.setState({
      isHovering: true
    })
  }

  goToPath(e) {
    e.preventDefault()
    switch (this.props.type) {
      case 'SALERY_PROCESSED_NOTIFICATION': {
        this.props.history.push('/wages')
        break
      }
      case 'END_OF_CONTRACT': {
        this.props.history.push('/editUsers/' + this.props.refId)
        break
      }
      case 'END_OF_PROBATION': {
        this.props.history.push('/editUsers/' + this.props.refId)
        break
      }
      case 'PROBATION_FEEDBACK_SURVEY': {
        this.props.history.push('/manager-feedback-surveys?surveyId=' + this.props.refId)
        break
      }
      case 'MANAGER_FEEDBACK_RESULT_READY': {
        this.openFeedbackModal()
        break
      }
      case 'LAST_DAY_ON_WORK': {
        this.props.history.push('/editUsers/' + this.props.refId)
        break
      }
      case 'HO_OFFICE_RETURN': {
        this.props.history.push('/editUsers/' + this.props.refId)
        break
      }
      case 'END_OF_MATERNITY_LEAVE': {
        this.props.history.push('/editUsers/' + this.props.refId)
        break
      }
      case 'LEAVE_APPROVED_NOTIFICATION': {
        this.props.history.push('/leaves/' + this.props.refId)
        break
      }
      case 'LEAVE_REJECTED_NOTIFICATION': {
        this.props.history.push('/leaves/' + this.props.refId)
        break
      }
      case 'NEW_LEAVE_NOTIFICATION': {
        this.props.history.push('/manageLeaves/' + this.props.createdBy + '/' + this.props.refId)
        break
      }
      case 'CAR_USAGE_APPROVED_NOTIFICATION': {
        this.props.history.push('/bookings/' + this.props.refId)
        break
      }
      case 'CAR_USAGE_REJECTED_NOTIFICATION': {
        this.props.history.push('/bookings/' + this.props.refId)
        break
      }
      case 'NEW_CAR_USAGE_NOTIFICATION': {
        this.props.history.push('/manageBookings/' + this.props.createdBy + '/' + this.props.refId)
        break
      }
      case 'VEHICLE_RESERVATION_APPROVED_NOTIFICATION':
      case 'VEHICLE_RESERVATION_PARTICIPANT_JOINED_NOTIFICATION':
      case 'VEHICLE_RESERVATION_REJECTED_NOTIFICATION': {
        this.props.history.push('/vehicle-reservations?reservationId=' + encodeURIComponent(this.props.refId))
        break
      }
      case 'OVERTIME_TICKET_WF_APPROVED': {
        window.location.href = `${TICKETING_APP}`
        break
      }
      case 'OVERTIME_TICKET_REJECTED': {
        window.location.href = `${TICKETING_APP}`
        break
      }
      case 'PAYROLL_TICKET_NEW': {
        window.location.href = `${TICKETING_APP}`
        break
      }
      case 'PAYROLL_TICKET_CLOSED': {
        window.location.href = `${TICKETING_APP}`
        break
      }
      case 'NEW_USER_CREATED': {
        this.props.history.push('/editUsers/' + this.props.refId)
        break
      }
      case 'ACADEMY_SIDE_BY_SIDE_GROUP_CREATED': {
        // Navigate to academy or group management page in ticketing app
        window.location.href = `${TICKETING_APP}/academy/groups/` + this.props.refId
        break
      }
      case 'PAYROLL_TICKET_OVERDUE': {
        window.location.href = `${TICKETING_APP}`
        break
      }
      case 'PAYROLL_TICKET_UPDATED': {
        window.location.href = `${TICKETING_APP}`
        break
      }
      case 'BILLING_REQUEST_SUBMITTED':
      case 'BILLING_REQUEST_APPROVED':
      case 'BILLING_REQUEST_REJECTED': {
        window.location.href = `${TICKETING_APP}/bills`
        break
      }
      default: {
        return
      }
    }
  }

  async markAsRead(e) {
    e.preventDefault()
    if (this.props.id && this.state.isRead === false) {
      await this.setState({ isRead: true })

      axios
        .post('notification/markread', { notification_id: this.props.id })
        .then((response) => {
          if (response.data.success) {
          } else {
            pubsub.publish('showNotification', {
              message: response.data.message,
              type: 'error'
            })
          }
        })
        .catch((e) => {
          console.error('Notification could not be marked as read', e)
        })
    }
  }

  _getIconFromType = (type) => {
    switch (type) {
      case 'SALERY_PROCESSED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-success'></em>
            <em className='fa fa-money-bill fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'LEAVE_APPROVED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-success'></em>
            <em className='far fa-clock fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'LEAVE_REJECTED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-danger'></em>
            <em className='far fa-clock fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'NEW_LEAVE_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-warning'></em>
            <em className='far fa-clock fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }

      case 'CAR_USAGE_APPROVED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-success'></em>
            <em className='far fa-clock fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'CAR_USAGE_REJECTED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-danger'></em>
            <em className='far fa-clock fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'NEW_CAR_USAGE_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-warning'></em>
            <em className='far fa-clock fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }

      case 'VEHICLE_RESERVATION_APPROVED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-success'></em>
            <em className='fa fa-car fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'VEHICLE_RESERVATION_PARTICIPANT_JOINED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-info'></em>
            <em className='fa fa-car fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'VEHICLE_RESERVATION_REJECTED_NOTIFICATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-danger'></em>
            <em className='fa fa-car fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'LAST_DAY_ON_WORK': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-dark'></em>
            <em className='fa fa-user-times fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'END_OF_CONTRACT': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-muted'></em>
            <em className='fa fa-sticky-note fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'END_OF_PROBATION': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-muted'></em>
            <em className='fa fa-briefcase fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'PROBATION_FEEDBACK_SURVEY': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-primary'></em>
            <em className='fa fa-comment fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'MANAGER_FEEDBACK_RESULT_READY': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#ffb822' }}></em>
            <em className='fa fa-star fa-stack-1x fa-inverse' style={{ color: '#fff' }}></em>
          </span>
        )
      }
      case 'HO_OFFICE_RETURN': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-info'></em>
            <em className='fa fa-building fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'END_OF_MATERNITY_LEAVE': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-warning'></em>
            <em className='fa fa-female fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
      case 'OVERTIME_TICKET_WF_APPROVED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#28a745' }}></em>
            <em className='fas fa-calendar-alt fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }

      case 'OVERTIME_TICKET_REJECTED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#dc3545' }}></em>
            <em className='fas fa-calendar-alt fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'PAYROLL_TICKET_NEW': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#17a2b8' }}></em>
            <em className='fa fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }

      case 'PAYROLL_TICKET_CLOSED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#28a745' }}></em>
            <em className='fa fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }

      case 'PAYROLL_TICKET_OVERDUE': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#dc3545' }}></em>
            <em className='fa fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'PAYROLL_TICKET_UPDATED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#17a2b8' }}></em>
            <em className='fa fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'BILLING_REQUEST_SUBMITTED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#17a2b8' }}></em>
            <em className='fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'BILLING_REQUEST_APPROVED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#28a745' }}></em>
            <em className='fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'BILLING_REQUEST_REJECTED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#dc3545' }}></em>
            <em className='fa fa-money-bill fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'NEW_USER_CREATED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#28a745' }}></em>
            <em className='fa fa-user-plus fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'ACADEMY_SIDE_BY_SIDE_GROUP_CREATED': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x' style={{ color: '#17a2b8' }}></em>
            <em className='fa fa-graduation-cap fa-stack-1x fa-inverse' style={{ color: '#ffffff' }}></em>
          </span>
        )
      }
      case 'MONTHLY_TARGET_HOURS_MISSING': {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-warning'></em>
            <em className='fa fa-bell fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }

      default: {
        return (
          <span className='fa-stack'>
            <em className='fa fa-circle fa-stack-2x text-warning'></em>
            <em className='fa fa-tasks fa-stack-1x fa-inverse text-white'></em>
          </span>
        )
      }
    }
  }

  _getTextColorFromType = (type) => {
    switch (type) {
      case 'SALERY_PROCESSED_NOTIFICATION': {
        return 'text-success'
      }
      case 'LEAVE_APPROVED_NOTIFICATION': {
        return 'text-success'
      }
      case 'LEAVE_REJECTED_NOTIFICATION': {
        return 'text-danger'
      }
      case 'NEW_LEAVE_NOTIFICATION': {
        return 'text-warning'
      }
      case 'CAR_USAGE_APPROVED_NOTIFICATION': {
        return 'text-success'
      }
      case 'CAR_USAGE_REJECTED_NOTIFICATION': {
        return 'text-danger'
      }
      case 'NEW_CAR_USAGE_NOTIFICATION': {
        return 'text-warning'
      }
      case 'VEHICLE_RESERVATION_APPROVED_NOTIFICATION': {
        return 'text-success'
      }
      case 'VEHICLE_RESERVATION_PARTICIPANT_JOINED_NOTIFICATION': {
        return 'text-info'
      }
      case 'VEHICLE_RESERVATION_REJECTED_NOTIFICATION': {
        return 'text-danger'
      }
      case 'LAST_DAY_ON_WORK': {
        return 'text-dark'
      }
      case 'END_OF_CONTRACT': {
        return 'text-muted'
      }
      case 'END_OF_PROBATION': {
        return 'text-success'
      }
      case 'PROBATION_FEEDBACK_SURVEY': {
        return 'text-primary'
      }
      case 'MANAGER_FEEDBACK_RESULT_READY': {
        return 'text-warning'
      }
      case 'HO_OFFICE_RETURN': {
        return 'text-info'
      }
      case 'END_OF_MATERNITY_LEAVE': {
        return 'text-warning'
      }
      case 'OVERTIME_TICKET_WF_APPROVED': {
        return 'text-success'
      }
      case 'OVERTIME_TICKET_REJECTED': {
        return 'text-danger'
      }
      case 'PAYROLL_TICKET_NEW': {
        return 'text-info'
      }
      case 'PAYROLL_TICKET_CLOSED': {
        return 'text-success'
      }
      case 'PAYROLL_TICKET_OVERDUE': {
        return 'text-danger'
      }
      case 'PAYROLL_TICKET_UPDATED': {
        return 'text-info'
      }
      case 'BILLING_REQUEST_SUBMITTED': {
        return 'text-info'
      }
      case 'BILLING_REQUEST_APPROVED': {
        return 'text-success'
      }
      case 'BILLING_REQUEST_REJECTED': {
        return 'text-danger'
      }
      case 'ACADEMY_SIDE_BY_SIDE_GROUP_CREATED': {
        return 'text-info'
      }
      case 'MONTHLY_TARGET_HOURS_MISSING': {
        return 'text-warning'
      }
      default: {
        return 'text-warning'
      }
    }
  }

  render() {
    const { type, title, message, path } = this.props
    const isRead = this.state.isRead ? null : styles.unRead
    const isHovering = this.state.isHovering ? styles.hover : null
    return (
      <div
        onClick={this.markAsRead}
        className={`list-group-item cursor-pointer`}
        style={{ ...isRead, ...isHovering, padding: '3px 10px 3px 10px' }}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div className='media'>
          <div className='align-self-start mr-2' onClick={this.goToPath}>
            {this._getIconFromType(type)}
          </div>
          <div className='media-body text-truncate' onClick={this.goToPath}>
            <p className='mb-1'>
              <span className={`${this._getTextColorFromType(this.props.type)} m-0 ${path && 'cursor-pointer'}`}>{title}</span>
            </p>
            <p className={`m-0 ${path && 'cursor-pointer'}`}>
              <small>{message}</small>
            </p>
          </div>
          {!this.state.isRead && this.state.isHovering && (
            <div className='align-self-end mr-2' style={{ position: 'relative', top: -5 }}>
              <span className='fa-stack'>
                <em className={`fas fa-check-square fa-stack-2x fa-inverse text-green`}></em>
              </span>
            </div>
          )}
          <div className='ml-auto' onClick={this.goToPath}>
            <small className='text-muted ml-2'>{this.props.createdDate && moment(this.props.createdDate).fromNow()}</small>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  hover: {
    backgroundColor: 'rgb(217, 222, 245)'
  },
  unRead: {
    fontWeight: '900',
    backgroundColor: '#e4e7f5'
  }
}

NotificationItem.defaultProps = {
  type: 'INFO',
  title: 'Njoftim',
  message: 'Njoftim i ri eshte postuar',
  path: null,
  isRead: false,
  id: null,
  createdDate: null,
  refId: null
}

export default withRouter(NotificationItem)
